import type { BridgeCapabilities, BridgeTransport } from "#bridge/types";
import type { SdkEnvelope } from "#envelope";

const NOOP_CAPABILITIES: BridgeCapabilities = {
	outbound: false,
	inbound: false,
	rpc: false,
};

/** Browser / Storybook: accepts subscribe but never connects. */
export function createNoopTransport(capabilities: BridgeCapabilities = NOOP_CAPABILITIES): BridgeTransport {
	const handlers = new Set<(message: SdkEnvelope) => void>();

	return {
		capabilities,
		connected: false,
		send() {},
		subscribe(handler) {
			handlers.add(handler);
			return () => handlers.delete(handler);
		},
		whenConnected(timeoutMs = 0) {
			if (timeoutMs <= 0) {
				return Promise.reject(new Error("bridge: no channel"));
			}
			return new Promise((_, reject) => {
				setTimeout(() => reject(new Error("bridge: no channel")), timeoutMs);
			});
		},
		destroy() {
			handlers.clear();
		},
	};
}
